export default __webpack_public_path__ + "static/media/alert.8c1d31a6.svg";